import { getAuthToken } from '@/utils/local-storage'
import HttpRequest from './HttpRequest'

export default class BrandProvider extends HttpRequest {
  getBrandWarehouse () {
    this.setHeader(getAuthToken())
    return this.get('/brands/warehouse/all')
  }

  getBrands () {
    this.setHeader(getAuthToken())
    return this.get('/brands')
  }

  updateBrandDetail (params, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/brands/${params}/`, payload)
  }
}
